// src/services/addressServices.js
import { authAxiosInstance } from "../utils/axiosinstance";

/**
 * دریافت لیست آدرس‌های کاربر
 */
export const getAddresses = ({ userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.get('/api/v1/users/addresses/');
};

/**
 * افزودن آدرس جدید
 */
export const addAddress = (data, { userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.post('/api/v1/users/addresses/', data);
};

/**
 * ویرایش آدرس
 */
export const updateAddress = (addressId, data, { userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.put(`/api/v1/users/addresses/${addressId}/`, data);
};

/**
 * حذف آدرس
 */
export const deleteAddress = (addressId, { userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.delete(`/api/v1/users/addresses/${addressId}/`);
};

/**
 * تنظیم یک آدرس به عنوان پیش‌فرض
 */
export const setDefaultAddress = (addressId, { userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.put(`/api/v1/users/addresses/${addressId}/`, { is_default: true });
};